export const data = [
  {
    project: "Foster Together",
    stack: "React, Formik, Node.js, Javascript, Styled-Components, Yup",
    start: "12-2019",
    end: "03-2020",
    deployed: "",
    github: "",
    description:
      "An application to organize data for a non-profit organization that helps foster parent's recieve help from others outside of the home",
  },
  {
    project: "Fanatics Gym",
    stack: "React, Formik, Node.js, Javascript, Yup",
    start: "12-2019",
    end: "Present",
    deployed: "https://fanatics-gym.vercel.app/",
    github: "https://github.com/Fanatics-Gym/Front-End",
    description:
      "An E-commerce site, that promotes fitness and personal well-being. The sight also handles the application process for a football league where users can apply to play in the league",
  },
  // {
  //   project: "Tracker",
  //   stack: "React, Javascript",
  //   start: "03-2020",
  //   end: "Present",
  //   deployed: "",
  //   github: "",
  //   description: "Multi purpose tracker, that has two lists",
  // },
  {
    project: "Timer",
    stack: "React, Javascript, Sass",
    start: "06-2020",
    end: "06-2020",
    deployed: "https://timer-two.vercel.app/",
    github: "https://github.com/jarrod847/timer",
    description:
      "A timer were you can set the amount of mins or seconds it will count down from. The sight also offers a stop-watch for users to time themselves, being able to stop and start at anytime",
  },
  {
    project: "Conways Game of Life",
    stack: "React, Javascript, Sass",
    start: "05-2020",
    end: "05-2020",
    deployed: "https://gameoflife-jarrodskahill.now.sh/",
    github: "https://github.com/jarrod847/GameOfLife",
    description:
      "A game that runs by itself, click a few squares and click start and watch it follow a set of rules",
  },
];
